import { Button, Form, Input, message, Modal, notification, Skeleton, Table, Tag, } from 'antd'
import { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import invoiceService from '../../../services/invoice-service';
import html2pdf from "html2pdf.js";
import InvoicePdf from './InvoicePdf';
import { FiCopy } from "react-icons/fi";
import { HiCheck } from "react-icons/hi";
import { changeDocumentTitle } from '../../../utils/title';
import { checkPermission } from '../../../utils/permissions';
import { CiEdit } from "react-icons/ci";
import dayjs from 'dayjs';
import CardSkeleton from '../../../utils/skeleton';
import { ROLES } from '../../../constants';
import ExtraChangesModal from '../../adminPortal/invoices/ExtraChangesModal';
import { RxCross2 } from "react-icons/rx";

function CustomerViewInvoice() {

    const { id } = useParams();
    const [form] = Form.useForm();
    const role = localStorage.getItem("role");

    const [logsLoader, setLogsLoader] = useState(false);
    const [forceRefresh, setForceRefresh] = useState(true);

    const componentRef = useRef();

    const [loading, setLoading] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [invoice, setInvoice] = useState(null); // better as object, not []
    const [extra, setExtra] = useState([]);
    const [data, setData] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [vehicles, setVehicles] = useState([]);
    const [copied, setCopied] = useState(false);
    const [isModalshow, setIsModalShow] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [log, setLog] = useState([])
    const [open, setOpen] = useState(false);
    const [logPagination, setLogPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 10,
    });
    const [invoiceInfo, setInvoiceInfo] = useState({});
    // const [mailLoading, setMailLoading] = useState(false)
    const [status, setStatus] = useState("hide");

    const [isEditing, setIsEditing] = useState(false);
    // editable copies
    const [editableVehicles, setEditableVehicles] = useState([]);
    const [editableInvoice, setEditableInvoice] = useState({
        discount: 0,
        total_freight_charges: 0,
        total_loading_charges: 0,
    });

    const handleCopy = () => {
        if (invoice?.container_number) {
            navigator.clipboard.writeText(invoice?.container_number);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500); // reset after 1.5s
        }
    };

    const handleStatus = () => {
        setStatus((prev) => (prev === "show" ? "hide" : "show"));
    };

    const handlePrint = () => {
        window.print();
    };

    const handleDownload = () => {
        setPdfLoading(true);
        if (!invoice) {
            console.error("Invoice not loaded yet");
            return;
        }
        if (!componentRef.current) {
            console.error("InvoicePdf not rendered");
            return;
        }
        const opt = {
            margin: [0, 0],  // ✅ no extra margin
            filename: `invoice-${invoice?.id || "draft"}.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: "px", format: [794, 1040], orientation: "portrait" }, // ✅ exact A4 in px
        };

        html2pdf().set(opt).from(componentRef.current).save();
        setPdfLoading(false);
    };

    const getLogsData = async (page = 1, pageSize = logPagination.pageSize) => {
        setLogsLoader(true)
        const responselog = await invoiceService.logs(id, page, pageSize);
        setLogsLoader(false)

        setInvoiceInfo(responselog.data?.invoice);
        setLog(responselog.data?.logs?.data)
        setLogPagination((prev) => ({
            ...prev,
            total: responselog.data?.logs?.total,
            current: page,
            pageSize
        }));
    }

    const initialize = async () => {
        setLoading(true);
        const response = await invoiceService.viewInvoice(id);

        setLoading(false);

        if (response?.success) {
            setInvoice(response.data.invoice);
            setVehicles(response.data.invoice.vehicles || []);
            setData(response.data);
            setExtra(response.data?.extras);
            setCustomer(response.data?.customer);
        }
    };

    useEffect(() => {
        changeDocumentTitle("View Invoice");
        if (forceRefresh) {
            initialize();
            getLogsData();
            setForceRefresh(false)
        }
    }, [id, forceRefresh]); // added id as dependency

    const columns = [
        {
            title: <span className="text-left block">Vehicle</span>,
            dataIndex: "vehicle",
            key: "vehicle",
            align: 'left',
            render: (text, record) => (
                <span className=' block text-left'>
                    {record.year} {record.vehicle} {record.product}
                    <br />
                    <span className='text-[#606A72]'>{record.chasis_no}</span>
                </span>
            )
        },
        {
            title: <span className="text-left block">Receiving Date</span>,
            dataIndex: "date_rcd",
            key: "date_rcd",
            align: 'left',
            render: (text, record) => (
                <span className='block text-left'>
                    {record.date_rcd
                        ? dayjs(record.date_rcd).format("DD-MMM-YYYY")
                        : null}
                </span>
            )
        },
        {
            title: <span className="text-left block">Loading Date</span>,
            dataIndex: "pull_out_date",
            key: "Loading",
            align: 'left',
            render: (text) => (
                <span className='block text-left'>
                    {dayjs(invoice?.pull_out_date).format("DD-MMM-YYYY")}
                </span>
            )
        },
        {
            title: "Days",
            dataIndex: "days",
            key: "days",
        },
        {
            title: "Storage",
            dataIndex: "yard_charges",
            key: "Storage",
            render: (text, record) => {
                const row = editableVehicles.find(v => v.id === record.id);
                return isEditing ? (
                    <Input
                        type="number"
                        size="small"
                        value={row?.yard_charges}
                        onChange={(e) => {
                            const value = Number(e.target.value || 0);
                            setEditableVehicles(prev =>
                                prev.map(v =>
                                    v.id === record.id
                                        ? { ...v, yard_charges: value }
                                        : v
                                )
                            );
                        }}
                    />
                ) : (
                    <span>${record?.yard_charges}</span>
                );

            }

        },
        {
            title: "Towing",
            dataIndex: "towing_charges",
            key: "towing_charges",
            render: (_, record) => {
                const row = editableVehicles.find(v => v.id === record.id);

                return isEditing ? (
                    <Input
                        type="number"
                        size="small"
                        value={row?.towing_charges}
                        onChange={(e) => {
                            const value = Number(e.target.value || 0);
                            setEditableVehicles(prev =>
                                prev.map(v =>
                                    v.id === record.id
                                        ? { ...v, towing_charges: value }
                                        : v
                                )
                            );
                        }}
                    />
                ) : (
                    <span>${record?.towing_charges}</span>
                );
            },
        },

        {
            title: "Other Charges",
            dataIndex: "other_charges",
            key: "other_charges",
            render: (_, record) => {
                const row = editableVehicles.find(v => v.id === record.id);

                return isEditing ? (
                    <Input
                        type="number"
                        size="small"
                        value={row?.other_charges || 0}
                        onChange={(e) => {
                            const value = Number(e.target.value || 0);
                            setEditableVehicles(prev =>
                                prev.map(v =>
                                    v.id === record.id
                                        ? { ...v, other_charges: value }
                                        : v
                                )
                            );
                        }}
                    />
                ) : (
                    <span>${Number(record?.other_charges || 0).toFixed(0)}</span>
                );
            },
        },

        {
            title: "Total",
            dataIndex: "total",
            key: "total",
            render: (text, record) => (
                <span>
                    ${(Number(record?.towing_charges) || 0) + (Number(record?.yard_charges) || 0) + (Number(record?.other_charges) || 0)}

                    {/* {invoice?.total_storage_charges + invoice?.total_towing_charges} */}
                </span>
            )
        },
    ];

    const tableColumns = [
        {
            title: "Entity",
            dataIndex: "entity",
            key: "entity",
            render: (text) => <Tag color="blue">{text.toUpperCase()}</Tag>,
        },
        {
            title: "Vehicle ID",
            dataIndex: "vehicle_id",
            key: "vehicle_id",
            render: (id) => id ?? "-",
        },
        {
            title: "Field",
            dataIndex: "field",
            key: "field",
            render: (text) => <b>{text.replaceAll("_", " ")}</b>,
        },
        {
            title: "Extra Charge",
            dataIndex: "extra_charge_name",
            key: "extra_charge_name",
            render: (name) => name ?? "-",
        },
        {
            title: "Old Value",
            dataIndex: "old_value",
            key: "old_value",
            render: (val) => <span className="text-red-500">{val}</span>,
        },
        {
            title: "New Value",
            dataIndex: "new_value",
            key: "new_value",
            render: (val) => <span className="text-green-600">{val}</span>,
        },
        {
            title: "Edited By",
            dataIndex: "edited_by",
            key: "edited_by",
        },
        {
            title: "Edited At",
            dataIndex: "edited_at",
            key: "edited_at",
        },
    ];

    const maskEmail = (email) => {
        if (!email) return "";
        const [name, domain] = email.split("@");

        // Show first 3 characters, mask the rest
        const maskedName = name.slice(0, 3) + "*".repeat(Math.max(0, name.length - 3));

        return `${maskedName}@${domain}`;
    };

    const totalAmount = invoice?.total - (-data?.credit_amount);
    // const totalOtherCharges = invoice?.total_storage_charges + invoice?.total_towing_charges
    const DueAmount = totalAmount - (data?.collected_amount)

    const totalExtraAmount = extra.reduce(
        (sum, ext) => sum + Number(ext.extra_charge_amount || 0),
        0
    );

    const formatNumber = (value) => {
        if (!value) return "0.00";
        return Number(value).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const handleApprove = async () => {
        setLoading(true)
        const response = await invoiceService.approveInvoice(invoice?.id);
        setLoading(false)
        if (response.success) {
            message.info(`${response.data.emailSended}`)
            // notification.success({
            //   message: "Invoice Approved!",
            //   description: response.message,
            //   placement: "topRight",
            // });
        }
        initialize();
        setIsModalShow(false);
    };

    const showModal = () => {
        setIsModalShow(true);
    };

    const handleCancel = () => {
        setIsModalShow(false);
        setIsModalVisible(false);

    };

    const visibleModal = () => setIsModalVisible(true);

    const updateInvoice = async () => {
        const payload = {
            discount: editableInvoice.discount,
            total_freight_charges: editableInvoice.total_freight_charges,
            total_loading_charges: editableInvoice.total_loading_charges,

            extraCharge: extra.map(e => e.extra_charge),
            extraChargeAmount: extra.map(e => e.extra_charge_amount),

            yard_charges: editableVehicles.reduce((acc, v) => {
                acc[v.id] = Number(v.yard_charges || 0);
                return acc;
            }, {}),

            towing_charges: editableVehicles.reduce((acc, v) => {
                acc[v.id] = Number(v.towing_charges || 0);
                return acc;
            }, {}),

            other_charges: editableVehicles.reduce((acc, v) => {
                acc[v.id] = Number(v.other_charges || 0);
                return acc;
            }, {}),
        };

        setLoading(true);
        const response = await invoiceService.updateInvoice(invoice.id, payload);
        setLoading(false);

        if (response.success) {
            notification.success({ message: "Invoice updated successfully" });
            setIsEditing(false);
            setForceRefresh(true);
        }
    }

    const onFinish = async (values) => {
        setExtra(values.charges.map(c => ({
            extra_charge: c.first,
            extra_charge_amount: c.last,
        })));
        setIsModalVisible(false);
    };

    const modalLog = (
        <Modal
            title="Invoice Logs"
            open={open}
            style={{ top: 15 }}
            centered={false}
            onCancel={() => setOpen(false)}
            footer={null}
            width={1000}
        >
            <div className="mb-4 p-2 bg-gray-50 rounded-md border">
                <div className="flex justify-around items-center  text-base">
                    <div>
                        <p className="text-xs text-gray-500 p-0 m-0  ">Invoice ID</p>
                        <p className="font-semibold">
                            {logsLoader ? <Skeleton.Input className='!rounded-xl !h-5' size='small' active /> : invoiceInfo?.id ?? 0}
                        </p>
                    </div>

                    <div>
                        <p className="text-xs text-gray-500 p-0 m-0 ">Approved By</p>
                        <p className='font-semibold'>
                            {logsLoader ? <Skeleton.Input className='!rounded-xl !h-5' size='small' active /> : invoiceInfo?.approved_by ?? '-'}
                        </p>
                    </div>

                    <div>
                        <p className="text-xs text-gray-500 p-0 m-0 ">Approved At</p>
                        <p className="font-semibold">
                            {logsLoader
                                ? <Skeleton.Input className='!rounded-xl !h-5' size='small' active />
                                : invoiceInfo?.approved_at ? dayjs(invoiceInfo.approved_at).format("DD-MMM-YYYY") : '-'
                            }
                        </p>
                    </div>

                    <div>
                        <p className="text-xs text-gray-500 p-0 m-0 ">Issued Date</p>
                        <p className="font-semibold">
                            {logsLoader ? <Skeleton.Input className='!rounded-xl !h-5' size='small' active /> : invoiceInfo.created_at ? dayjs(invoiceInfo.created_at).format("DD-MMM-YYYY") : '-'}
                        </p>
                    </div>
                </div>
            </div>

            <Table
                rowKey={(record, index) => index}
                columns={tableColumns}
                dataSource={log}
                loading={logsLoader}
                pagination={{
                    current: logPagination.current,
                    total: logPagination.total,
                    pageSize: logPagination.pageSize,
                    onChange: (page) => getLogsData(page, logPagination.pageSize), // ✅ FIXED pagination
                    showSizeChanger: false,
                }}
                bordered
            />
        </Modal>
    )
    const modal = (
        <Modal
            title={<div style={{ textAlign: "center" }}>Confirm</div>}
            open={isModalshow}
            onOk={handleApprove}
            onCancel={handleCancel}
            centered
            styles={{
                body: {
                    padding: "10px",
                },
            }}
            width={300}
            footer={
                <div className="flex justify-center gap-3">
                    <Button
                        type="default"
                        onClick={handleCancel}
                        style={{ width: "30%" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        onClick={handleApprove}
                        loading={loading}
                    // style={{ width: "30%" }}
                    >
                        Yes do it
                    </Button>
                </div>
            }
        >
            <p style={{ textAlign: "center" }}>
                You sure you want to approve this invoice and send to customer?
            </p>
        </Modal>
    );
    return (
        <div>
            <div className='flex items-center justify-between'>
                <h1 className='text-xl font-semibold'>Invoice Details</h1>
                <h2 className='text-center  bg-[#E0E4FF] w-40 px-4 py-1  rounded-xl text-base text-[#3D53E2]'>Invoice # {invoice?.id}</h2>
            </div>

            <div className='flex justify-end my-6'>
                <div className='flex gap-3'>
                    <Link to={'/invoice'}>
                        <Button className='rounded-xl'>Back</Button>
                    </Link>
                    <Button className='rounded-xl' onClick={handlePrint}>
                        Print
                    </Button>
                    {/* ...your buttons */}
                    <Button className="rounded-xl bg-black text-white" onClick={handleDownload} loading={pdfLoading}>
                        Download PDF
                    </Button>

                    {role !== ROLES.CUSTOMER &&
                        <>
                            {invoice?.status === 0 && (
                                <div className='flex gap-3'>
                                    {isEditing &&
                                        <div className='flex gap-3'>
                                            <Button
                                                type="primary"
                                                onClick={updateInvoice}
                                            >
                                                Save Changes
                                            </Button>

                                            <Button onClick={visibleModal} className='rounded-xl'>
                                                Add Extra Charges
                                            </Button>
                                        </div>
                                    }
                                    {isEditing ? <Button
                                        icon={<RxCross2 />}
                                        className="rounded-xl"
                                        onClick={() => setIsEditing(false)}
                                    >
                                        Cancel
                                    </Button> :

                                        <Button
                                            icon={<CiEdit />}
                                            className="rounded-xl"

                                            onClick={() => {
                                                setEditableVehicles(vehicles.map(v => ({ ...v })));
                                                setEditableInvoice({
                                                    discount: invoice?.discount || 0,
                                                    total_freight_charges: invoice?.freight_charges || 0,
                                                    total_loading_charges: invoice?.total_loading_charges || 0,
                                                });
                                                setIsEditing(true);
                                            }}
                                        >
                                            Edit
                                        </Button>
                                    }

                                    {checkPermission("APPROVE_INVOICE") && <Button onClick={showModal} className='rounded-xl'>
                                        Approve & Send
                                    </Button>}
                                </div>
                            )}

                            <Button className='bg-black text-white' onClick={() => setOpen(true)}>Logs</Button>
                        </>
                    }

                    {/* {invoice?.status === 1 &&
                        <Button loading={mailLoading} icon={<SendOutlined />} className='rounded-xl' onClick={() => sendMail(invoice?.id, invoice?.user_id)}>
                            Re-send
                        </Button>} */}
                </div>
            </div>


            <div className='flex gap-5 w-full'>

                <div className="border h-36 rounded-xl py-2 pl-3 pr-2 bg-white w-[25%]">
                    {loading ?
                        <CardSkeleton />
                        :
                        <>
                            <h1 className='text-base w-full'>Amount Due</h1>
                            <div className='flex justify-between items-center mt-0 pt-0'>
                                <p className='text-xl text-[#E7000B]'>${DueAmount}</p>
                                {invoice?.is_partial === 0 ?
                                    <Tag color='red' className='mb-4'>Unpaid</Tag>
                                    : invoice?.is_partial === 1 ?
                                        <Tag color='yellow' className='mb-4'>Partial</Tag>
                                        : <Tag color='green' className='mb-4'>Paid</Tag>}
                            </div>
                        </>

                    }
                </div>

                <div className="border h-36 rounded-xl py-2 pl-3 pr-2 bg-white w-[25%]">
                    {loading ?
                        <CardSkeleton />
                        :
                        <>
                            <h1 className='text-base'>Invoice</h1>
                            <div className='flex'>
                                <div className='flex flex-col w-[55%] text-[#606A72] text-xs'>
                                    <p className='p-0 m-0'>Invoice Number: </p>
                                    <p className='p-0 m-0'>Issue Date: </p>
                                    <p className='p-0 m-0'>Due Date: </p>
                                    <p className='p-0 m-0'>Payment Terms: </p>
                                </div>
                                <div className='flex flex-col text-[#333333] pl-1 font-medium text-xs'>
                                    <span> {invoice?.id} </span>
                                    <span>{dayjs(invoice?.pull_out_date).format("DD-MMM-YYYY")}
                                    </span>
                                    <span >{dayjs(invoice?.due_date || "-").format("DD-MMM-YYYY")}</span>
                                    <span> Payable immediately</span>
                                </div>
                            </div>
                        </>
                    }
                </div>

                <div className="border h-36 rounded-xl py-2 pl-3 pr-2 bg-white  w-[25%]">
                    {loading ?
                        <CardSkeleton />
                        :
                        <>
                            <h1 className='text-base'>Booking</h1>
                            <div className='flex '>
                                <div className='flex flex-col w-[55%] text-[#606A72] text-xs '>
                                    <p className='p-0 m-0  '>Booking Number:</p>
                                    <p className='p-0 m-0 '>Port of Loading:</p>
                                    <p className='p-0 m-0 '>Port of Discharge:</p>
                                    <p className='p-0 m-0 '>Place of Receipt:</p>
                                    <p className='p-0 m-0'>Place of Delivery:</p>
                                </div>
                                <div className='flex flex-col text-xs text-[#333333] font-semibold text-left'>
                                    <span>{vehicles[0]?.booking_no} </span>
                                    <span>HOUSTON</span>
                                    <span className='pl-4'>{vehicles[0]?.towing_location || "-"} </span>
                                    <span>HOUSTON</span>
                                    <span className='pl-4'>{vehicles[0]?.towing_location || "-"}</span>
                                </div>
                            </div>
                        </>
                    }
                </div>

                <div className="border h-36 rounded-xl py-2 pl-3 pr-2 bg-white  w-[25%]">
                    {loading ?
                        <CardSkeleton />
                        :
                        <>
                            <h1 className='text-base'>Bill to</h1>
                            <div className='flex flex-col mt-2'>
                                <p className='text-xs font-semibold m-0'>{data?.customer?.name}</p>
                                <p className='text-[11px] w-full m-0 mb-1'>{maskEmail(data?.customer?.email)}</p>
                                <p className='text-[11px] w-full m-0'>{data?.customer?.address}</p>
                                <p className='text-[11px] w-full m-0'>{data?.customer?.city}</p>
                                <p className='text-[11px] w-full m-0'>{data?.customer?.country}</p>
                            </div>
                        </>

                    }

                </div>

            </div>

            <div className='flex mt-5 gap-4'>
                <div className='flex flex-col w-[76%] gap-3'>
                    <div className="customer1-table-wrapper" >
                        <Table
                            columns={columns}
                            dataSource={vehicles}
                            pagination={false}
                            loading={loading}
                            summary={() => (
                                <>
                                    <Table.Summary.Row className=" ">
                                        <Table.Summary.Cell colSpan={14}>
                                            <div className="  ">
                                                <span className="border block text-start bg-[#FAFAFA] text-[10px] p-2 font-semibold uppercase tracking-wide mb-2">
                                                    Extra Charges
                                                </span>

                                                <div className="flex flex-col gap-2">
                                                    {extra.map((ext, index) => (
                                                        <div key={index}
                                                            className="flex justify-between items-center text-xs text-[#000000]"
                                                        >
                                                            <span >
                                                                {ext.extra_charge}
                                                            </span>

                                                            <span className="font-medium">
                                                                ${Number(ext.extra_charge_amount).toFixed(2)}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                </>
                            )}
                        />

                        <div className='flex '>

                            <div className="border h-auto rounded-xl py-4 px-3 m-3 ml-auto bg-[#FBFBFB] w-[45%] flex flex-col">

                                {loading ?
                                    <CardSkeleton />
                                    :
                                    <>
                                        {/* First Block */}
                                        <div className="flex justify-between gap-y-2 border-b-2 pb-2 px-2 w-full text-xs">
                                            {/* Left Column */}
                                            <div className="flex flex-col gap-2 text-[#606A72]">
                                                <span className="text-[11px]">Total</span>
                                                <span>Storage</span>
                                                <span>Towing</span>
                                                <span>Other</span>
                                                <span>Extra Charges</span>

                                            </div>

                                            {/* Right Column */}
                                            <div className="flex flex-col  gap-2 text-[#333333] font-medium text-left w-[20%]">
                                                <span className="invisible">-</span>
                                                <span>${formatNumber(invoice?.total_storage_charges)}</span>
                                                <span>${formatNumber(invoice?.total_towing_charges)}</span>
                                                <span>${formatNumber(invoice?.total_other_charges)}</span>
                                                ${formatNumber(totalExtraAmount)}
                                            </div>
                                        </div>

                                        {/* Second Block */}
                                        <div className="flex justify-between gap-y-2 border-b-2 pb-2 px-2 pt-3 w-full text-xs">
                                            <div className="flex flex-col gap-2 text-[#606A72]">
                                                {isEditing ? (
                                                    <>
                                                        <span>Freight </span>
                                                        <span> Loading</span>
                                                    </>
                                                ) :
                                                    <span>Freight & Loading</span>}
                                                <span>Chassis Charges</span>
                                            </div>
                                            <div className={`flex flex-col gap-2 text-[#333333] font-medium text-left ${isEditing ? 'w-[25%]' : 'w-[20%]'}`}>
                                                <span>
                                                    {isEditing ? (
                                                        <div className='flex flex-col gap-1 '>
                                                            <Input
                                                                type="number"
                                                                size="small"
                                                                value={editableInvoice.total_freight_charges}
                                                                onChange={(e) =>
                                                                    setEditableInvoice(prev => ({
                                                                        ...prev,
                                                                        total_freight_charges: Number(e.target.value || 0),
                                                                    }))
                                                                }
                                                                className='w-full'
                                                            />
                                                            <Input
                                                                type="number"
                                                                size="small"
                                                                value={editableInvoice.total_loading_charges}
                                                                onChange={(e) =>
                                                                    setEditableInvoice(prev => ({
                                                                        ...prev,
                                                                        total_loading_charges: Number(e.target.value || 0),
                                                                    }))
                                                                }
                                                            />
                                                        </div>
                                                    ) : (
                                                        `$${formatNumber(invoice?.freight_charges + invoice?.total_loading_charges)}`
                                                    )}
                                                </span>
                                                <span>${formatNumber(invoice?.total_chasis_charges)}</span>
                                            </div>
                                        </div>

                                        {/* Third Block */}
                                        <div className="flex justify-between gap-y-2 border-b-2 pb-2 px-2 pt-3 w-full text-xs">
                                            <div className="flex flex-col gap-2 text-[#606A72] font-semibold">
                                                <span>Sub Total</span>
                                                <span>Discount</span>
                                                <span>Credit Amount</span>
                                            </div>
                                            <div className="flex flex-col gap-2 text-[#333333] font-medium text-left w-[20%]">
                                                <span>${formatNumber(data?.subTotal)}</span>
                                                <span>
                                                    {isEditing ? (
                                                        <Input
                                                            type="number"
                                                            size="small"
                                                            value={editableInvoice.discount}
                                                            onChange={(e) =>
                                                                setEditableInvoice(prev => ({
                                                                    ...prev,
                                                                    discount: Number(e.target.value || 0),
                                                                }))
                                                            }
                                                        />
                                                    ) : (
                                                        `$${formatNumber(invoice?.discount)}`
                                                    )}
                                                </span>
                                                <span>${formatNumber(data?.credit_amount)}</span>
                                            </div>
                                        </div>

                                        {/* Final Total */}
                                        <div className="flex justify-between pt-3 px-2 w-full text-sm">
                                            <div className="text-[#606A72] font-semibold">
                                                <span>Total Amount</span>
                                            </div>
                                            <div className="text-[#333333] font-medium text-left w-[20%]">
                                                <span>${formatNumber(totalAmount)}</span>
                                            </div>
                                        </div>
                                        <div className="flex justify-between pt-3 px-2 w-full text-sm">
                                            <div className="text-[#606A72] font-semibold">
                                                <span>Collection Amount</span>
                                            </div>
                                            <div className="text-[#333333] font-medium text-left w-[20%]">
                                                <span>${formatNumber(data?.collected_amount)}</span>
                                            </div>
                                        </div>
                                        <div className="flex justify-between pt-3 px-2 w-full text-sm">
                                            <div className="text-[#606A72] font-semibold">
                                                <span>Due Amount</span>
                                            </div>
                                            <div className="text-[#333333] font-medium text-left w-[20%]">
                                                <span>${formatNumber(DueAmount)}</span>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>

                    </div>
                    {role === ROLES.CUSTOMER &&
                        <div className="border h-auto rounded-xl py-4 px-10 bg-white">
                            {loading ?
                                <CardSkeleton />
                                :
                                <>
                                    <h1 className='text-base'>Invoice Notes</h1>
                                    <div className="flex flex-col gap-2 text-sm text-[#606A72]">
                                        <span>We do not accept CARD payments, only cashier's cheques or direct bank transfers. Any additional charges Government charges if any are applied will be charged at actual. Payment should fall into the Ctrade USA Inc account within 10 days after loading the container.</span>
                                        <span>Any dispute in invoice should be raised within 07 days from the issue date otherwise it will be considered as confirmed.</span>
                                        <span>
                                            Any invoice delayed from the due date will be subject to $100 as late fees. 15 Day free at facilities thereafter $15 Day/Car from the day of receiving. In and out charges will be $100 subject to storage charges.
                                        </span>
                                        <span>
                                            <strong>Note:</strong> Payment against this invoice will be accepted as terms and conditions confirmed. In case of delay in payment Ctrade USA will not be responsible for any storage demurrages/detentions.
                                        </span>
                                    </div>
                                    <p className='font-semibold mt-3'>THANK YOU FOR DOING BUSINESS WIITH CTRADE USA INC.</p>
                                </>
                            }
                        </div>
                    }
                </div >

                <div className='flex flex-col gap-3 w-[24%]'>

                    <div className="border  h-auto rounded-xl py-4 px-5 bg-white  w-full">
                        {loading ?
                            <CardSkeleton />
                            :
                            <>
                                <h1 className='text-base '>Container</h1>
                                <div className="flex justify-between w-full ">
                                    {/* Left Column */}
                                    <div className="flex flex-col gap-1 text-xs text-[#606A72]">
                                        <span>Container Number</span>
                                        <span>Size</span>
                                    </div>

                                    {/* Right Column */}
                                    <div className="flex flex-col text-xs text-[#333333] font-medium text-left">
                                        <div className="flex items-center gap-2">
                                            <span className="cursor-pointer hover:text-blue-600 transition">
                                                {invoice?.container_number || "-"}
                                            </span>
                                            <button
                                                onClick={handleCopy}
                                                className="p-1 rounded-md hover:bg-gray-100 active:scale-90 transition relative group"
                                            >
                                                {copied ? (
                                                    <HiCheck size={16} className="text-green-500" />
                                                ) : (
                                                    <FiCopy size={16} className="text-gray-500" />
                                                )}
                                                <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-[10px] text-white bg-black px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                                                    Copy
                                                </span>
                                            </button>
                                        </div>
                                        <span>{vehicles[0]?.container_size} ft</span>
                                    </div>
                                </div>
                            </>
                        }

                    </div>
                    <div className="border  h-auto rounded-xl py-4  px-4 bg-white  w-full">
                        {loading ?
                            <CardSkeleton />
                            :
                            <>
                                <div className='flex justify-between'>
                                    <h1 className='text-sm' >Bank Transfer and Payment Instructions</h1>
                                    {/* <span> */}
                                    <Button size='small' onClick={handleStatus} className='border p-1 rounded-md text-center' >{status === "hide" ? 'Show' : 'Hide'}</Button>
                                    {/* </span> */}
                                </div>
                                {/* {status === "show" && */}
                                <div
                                    className={`transition-all duration-700 ease-in-out overflow-hidden ${status === "show" ? "max-h-[800px] opacity-100" : "max-h-0 opacity-0"
                                        }`}
                                >
                                    <div className="flex flex-col text-xs w-full gap-2">
                                        {/* Row 1 */}
                                        <div className="flex justify-between">
                                            <span className="text-[#606A72] w-[45%]">Account Name</span>
                                            <span className="text-[#333333] font-medium uppercase w-[55%]">CTRade USA Inc</span>
                                        </div>

                                        {/* Row 2 */}
                                        <div className="flex justify-between">
                                            <span className="text-[#606A72] w-[45%]">Bank Name</span>
                                            <span className="text-[#333333] font-medium w-[55%]">Bank of America</span>
                                        </div>

                                        {/* Row 3 */}
                                        <div className="flex justify-between">
                                            <span className="text-[#606A72] w-[45%]">Account Number</span>
                                            <span className="text-[#333333] font-medium w-[55%]">4881 2067 9259</span>
                                        </div>

                                        {/* Row 4 */}
                                        <div className="flex justify-between">
                                            <span className="text-[#606A72] w-[45%]">Swift Code</span>
                                            <span className="text-[#333333] font-medium w-[55%]">BOFAUS3N</span>
                                        </div>

                                        {/* Row 5 */}
                                        <div className="flex justify-between">
                                            <span className="text-[#606A72] w-[45%]">Routing Number</span>
                                            <span className="text-[#333333] font-medium w-[55%]">
                                                111000023/111000025 (PAPER & ELECTRONICS)
                                            </span>
                                        </div>

                                        {/* Row 6 */}
                                        <div className="flex justify-between">
                                            <span className="text-[#606A72] w-[45%]">Routing Number</span>
                                            <span className="text-[#333333] font-medium w-[55%]">
                                                026009593 (WIRE TRANSFER, DOMESTIC)
                                            </span>
                                        </div>

                                        {/* Row 7 */}
                                        <div className="flex justify-between">
                                            <span className="text-[#606A72] w-[45%]">Branch Address</span>
                                            <span className="text-[#333333] font-medium w-[55%]">
                                                Bank of America, 22 Broadway, New York, NY 10038
                                            </span>
                                        </div>
                                    </div>
                                    <div >
                                        <p className='bg-[#FEFCE8] p-3 mt-4 text-[#D68606]'>Make payments using invoice number as reference, keep proof of payment attached for faster reconciliation.</p>
                                    </div>
                                </div>

                            </>
                        }
                        {/* } */}
                    </div>
                    {role === ROLES.CUSTOMER &&
                        <div className="border  h-auto rounded-xl py-4 px-5 bg-white  w-full">
                            {loading ?
                                <CardSkeleton />
                                :
                                <>
                                    <h1 className='text-base'>Support</h1>
                                    <div className=" text-xs text-[#606A72]">
                                        <span>Have a question,contact billing at <a
                                            href="mailto:ctrade@ctrade.us"
                                            className="text-blue-600 underline"
                                        >
                                            finance@ctrade.us
                                        </a>{" "} or call +1 832 476 2242</span>
                                    </div>
                                </>
                            }
                        </div>
                    }
                </div>

            </div >

            {
                invoice && (
                    <div
                        style={{
                            // position: "absolute",
                            // top: 0,
                            // left: "-9999px",
                            visibility: "hidden",
                            height: 0,
                            overflow: "hidden",
                        }}
                    >
                        <InvoicePdf ref={componentRef} invoice={invoice} customer={customer} data={data} />
                    </div>
                )
            }

            {/* <EditModal
                isModalVisible={isModalVisible}
                // handleOk={handleOk}
                handleCancel={handleCancel}
                invoice={invoice}
                loading={loading}
                columns={columns}
                onFinish={onFinish}
                form={form}
                vehicles={invoice?.vehicles?.length}
            /> */}
            <ExtraChangesModal
                isModalVisible={isModalVisible}
                handleCancel={handleCancel}
                loading={loading}
                onFinish={onFinish}
                form={form}
                extra={extra}
            />

            {modal}
            {modalLog}
        </div >
    )
}

export default CustomerViewInvoice
